import { useState, useMemo } from 'react'
import classname from 'classnames/bind'
import { Text, ExpandableCard, hooks as adcHooks, constants } from '@adc/ui-adc'
import styles from './styles.scss'
const cx = classname.bind(styles)
const { ColorNames } = constants

interface FAQData {
  title: string
  description: string
}

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const isMobile = adcHooks.useIsMobileHook()
  const heightHints = useMemo(() => {
    if (isMobile) {
      return {
        collapsed: 64,
        expanded: 300,
      }
    }
    return {
      collapsed: 64,
      expanded: 200,
    }
  }, [isMobile])

  const faqData: FAQData[] = [
    {
      title: 'How long does the selling process take?',
      description:
        'No, not with Auction.com’s SmartSale program. We do not pull your credit report as part of the listing process.',
    },
    {
      title: 'What fees do you charge?',
      description:
        'Yes. While the home is listed, you can continue to live in the home. You may request rentback as part of the listing process after the home is closed. If a foreclosure date has been scheduled, please coordinate with your listing agent on how foreclosure may impact your sale.',
    },
    {
      title: 'Can I set a minimum price?',
      description:
        'Auction.com’s SmartSale program is designed for any type of homeowners. However, homeowners facing foreclosure have found SmartSale program particularly beneficial to receive fast and fair offers.',
    },
    {
      title: 'What types of properties do you accept?',
      description:
        'You and your listing agent will have access to a listing portal to complete the listing process. Some examples of information we require are: photos, number of beds and baths, a listing description, selling strategy through auction or offer. A dedicated Auction.com concierge team will be available to provide support and guidance.',
    },
    {
      title: 'Do I need to make repairs before selling?',
      description:
        'You can see buyer demand in terms of number of views, saves and how many active bids or offers have been placed on your property in real-time, through the same listing portal provided by Auction.com. If the listing and pricing fits our buyer’s buybox, we typically see first bid or offer within 48 hours after a property is listed.',
    },
  ]
  return (
    <div className={cx('faq-full-width-section')}>
      <div className={cx('landing-section', 'faq-section-wrapper')}>
        <div className={cx('faq-header-section')}>
          <Text.Header level={1} color={ColorNames.GrayDark}>
            Frequently Asked Questions
          </Text.Header>
          <Text color={ColorNames.Gray} size='small' weight='normal'>
            Get answers to common questions about claiming your listing.
          </Text>
        </div>

        <div className={cx('faq-container')}>
          {faqData.map((faq, index) => (
            <div className={cx('faq-card')} key={index}>
              <ExpandableCard
                id={index}
                heightHints={heightHints}
                active={activeIndex === index}
                onClick={id =>
                  setActiveIndex(activeIndex === id ? null : (id as number))
                }
                fullPageExpandOnMobile={false}
                slots={{
                  header: () => (
                    <div className={cx('faq-header')}>
                      <div className={cx('faq-title')}>
                        <Text
                          style={{ lineHeight: '24px', fontWeight: '500' }}
                          size='small'
                          color={ColorNames.GrayDark}
                          content={faq.title}
                        />
                      </div>
                    </div>
                  ),
                  content: () => (
                    <div className={cx('faq-content')}>
                      <Text
                        color={ColorNames.Gray}
                        size='small'
                        weight='normal'
                        style={{ lineHeight: '26px' }}
                        content={faq.description}
                      />
                    </div>
                  ),
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FAQ
